<template>
    <router-view />
</template>

<script>
import axios from 'axios'
import vConsole from 'vconsole'

export default {
    name: 'App',
    mounted() {
        // let myConsole = new vConsole()
        // console.log(myConsole);

        // axios.get('/api').then((res) => {
        //     console.log(res.data);
        // })
    }
}
</script>

<style lang="less">
// .el-scrollbar {
//     >.el-scrollbar__bar {
//         opacity: 1 !important;
//         background-color: red;
//     }
// }

// .el-scrollbar .el-scrollbar__bar {
//     opacity: 1 !important;
//     background-color: red;
// }</style>



// WEBPACK FOOTER //
// src/App.vue